import { useDispatch } from 'react-redux'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { actions } from '../../InventoryState'

export default ({
  open, setOpen, idForCancel,
}) => {
  const dispatch = useDispatch()

  const onConfirmModal = () => {
    dispatch(actions.cancelInventory(idForCancel))
    setOpen(false)
  }

  return (
    <ConfirmOrRejectModal
      show={open}
      title='Cancelar lista'
      description='Você tem certeza que deseja cancelar o inventário?'
      onConfirm={() => onConfirmModal()}
      onReject={() => setOpen(false)}
      onClose={() => setOpen(false)}
    />
  )
}
